import { render, staticRenderFns } from "./settingData.vue?vue&type=template&id=67111a8a&scoped=true&"
import script from "./settingData.vue?vue&type=script&lang=js&"
export * from "./settingData.vue?vue&type=script&lang=js&"
import style0 from "./settingData.vue?vue&type=style&index=0&id=67111a8a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67111a8a",
  null
  
)

export default component.exports